import { Dropdown, Spinner } from 'react-bootstrap';
import { useDownloadAnalysisPdfMutation } from '@/app/ContentTools/api/aiContentAnalysisApi';
import type { ContentAnalysisType } from '@/app/ContentTools/types/aiContentAnalysisApiTypes';
import { errorMessage } from '@/utils/toast';

const ALL_ANALYSIS_TYPES: ContentAnalysisType[] = [
  'seo_analysis',
  'ai_detection',
  'eeat_analysis',
  'ai_search'
];

type DownloadScope = 'current' | 'all';

type AiAnalysisPdfDownloadMenuProps = {
  id?: string | number;
  currentType: ContentAnalysisType;
  keyword?: string;
};

const triggerBlobDownload = (blob: Blob, filename: string) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

const AiAnalysisPdfDownloadMenu = ({
  id,
  currentType,
  keyword
}: AiAnalysisPdfDownloadMenuProps) => {
  const [downloadAnalysisPdf, { isLoading: isDownloading }] =
    useDownloadAnalysisPdfMutation();

  const handleDownload = async (scope: DownloadScope) => {
    if (!id) {
      errorMessage('شناسه گزارش برای ساخت PDF پیدا نشد.');
      return;
    }

    try {
      const analysis_types =
        scope === 'all' ? ALL_ANALYSIS_TYPES : [currentType];
      const blob = await downloadAnalysisPdf({
        id,
        analysis_types
      }).unwrap();
      const suffix = scope === 'all' ? 'all' : currentType;
      triggerBlobDownload(
        blob,
        `ai-analysis-${suffix}-${keyword || 'report'}.pdf`
      );
    } catch {
      errorMessage('در دانلود فایل PDF خطایی رخ داد. لطفا دوباره تلاش کنید.');
    }
  };

  return (
    <Dropdown align="end">
      <Dropdown.Toggle
        size="sm"
        variant="outline-primary"
        disabled={isDownloading}
        className="d-inline-flex align-items-center justify-content-center"
      >
        {isDownloading ? (
          <>
            <Spinner
              animation="border"
              size="sm"
              style={{ width: 16, height: 16 }}
              className="me-1"
            />
            در حال تهیه PDF...
          </>
        ) : (
          'دانلود گزارش PDF'
        )}
      </Dropdown.Toggle>
      <Dropdown.Menu
        className="border py-0"
        renderOnMount
        popperConfig={{ strategy: 'fixed' } as never}
      >
        <Dropdown.Item
          className="link-600 fs--1 py-2"
          onClick={() => handleDownload('current')}
        >
          PDF همین گزارش
        </Dropdown.Item>
        <Dropdown.Item
          className="link-600 fs--1 py-2"
          onClick={() => handleDownload('all')}
        >
          PDF همه گزارش ها
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default AiAnalysisPdfDownloadMenu;
